// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__3ZHUj","header":"Footer_header__htqWd","links":"Footer_links__23FcF","iconWrapper":"Footer_iconWrapper__3vh_p"};